import React from 'react';
import Promise from 'bluebird';
import externalService from '../../service/external';
import shorterTotal from '../../util/shorterTotal';
import { appContext } from '../../util/decorators';

@appContext
export default class TotalShares extends React.PureComponent {
  static propTypes = {
    url: React.PropTypes.string.isRequired,
    suffix: React.PropTypes.bool,
  };

  constructor() {
    super();
    this.state = {
      total: false,
    };
  }

  componentDidMount() {
    this.getTotalCount();
  }

  async getTotalCount() {
    const [fbCount, twCount] = await Promise.all([
      externalService.getFacebookCount(this.props.url),
      externalService.getTwitterCount(this.props.url),
    ]);

    this.setState({
      total: fbCount.share_count + twCount,
    });
  }

  render() {
    const total = this.props.suffix ? shorterTotal(this.state.total) : this.state.total;

    if (!total) return null;

    return (
      <span className="share-button share-total">
        <span className="icon-container">
          <i className="icon-share"></i>
        </span>

        <span className="structural">{this.context.app.t('TotalShares.total_shares')}:</span> <span className="share-count">{total}</span>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/TotalShares.jsx